import { Box, Button, Typography } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react'
import filterSectionStyle from '../../styles/filterSectionStyle';
import RoleManagement from '../../security/roleManagement';
import { decodedJWT, getUserRole } from '../../utils/commonUtils';
import JWTTokenPayload from '../../interfaces/JWTTokenPayload';
import SearchResultGrid from '../searchResultGrid/searchResultGrid';
import ClientAgencyContract from '../../interfaces/clientAgencyContract';
import apiClient from '../../axiosClient';
import clientAgencyContractColumnDef from '../../colDef/clientAgencyContractColumnDef';
import AddClientAgencyContractModal from '../modals/addClientAgencyContractModal';
import { GridRowSelectionModel } from '@mui/x-data-grid';
import ActionConfirmationModal from '../modals/actionConfirmationModal';


const ManageContracts: React.FC = () => {
    const token: JWTTokenPayload | false = decodedJWT();
    const [openContractModal, setOpenContractModal] = useState(false);
    const [openDeactivateContractModal, setOpenDeactivateContractModal] = useState(false);
    const [contracts, setContracts] = useState<ClientAgencyContract[]>([]);
    const [selectedContractID, setSelectedContractID] = useState<string>('');

    const fetchContracts = async () => {
        try {
            const response = await apiClient.get(`/api/v1/contracts`);
            if (response.status === 200){
                setContracts(response.data);
            }
        } catch (error) {
            alert("Error, failed to fetch contracts: " + error);
        }
    };

    const deactivateContract = useCallback(async () => {
        try {
            const response = await apiClient.delete(`/api/v1/contracts/${selectedContractID}`);
            if (response.status === 200) {
                alert("Contract deactivated successfully");
                await fetchContracts();
            }
        } catch (error) {
            alert("Error, failed to deactivate contract: " + error);
        }
    }, [selectedContractID]);

    const handleSelectRow = (ids: GridRowSelectionModel) => {
        setSelectedContractID(contracts.find(val => ids.ids.has(val.contract_id))?.contract_id || '');
    };

    useEffect(() => {
        fetchContracts();
    }, []);

    return (
        <Box m={2}>
            {RoleManagement.isSuperAdmin(getUserRole(token)) && (
                <Box sx={filterSectionStyle}>
                    <Box display="flex" justifyContent="flex-end">
                        {selectedContractID && (
                            <Button
                                variant="contained"
                                onClick={() => setOpenDeactivateContractModal(true)}
                                color="warning" 
                                sx={{marginRight: '10px'}}
                            >
                                Deactivate Contract
                            </Button>
                        )}
                        <Button
                            variant="contained"
                            onClick={() => setOpenContractModal(true)}
                            color='primary' 
                        >
                            Create Contracts
                        </Button>
                    </Box>
                </Box>
            )}
            <Typography variant="h5" gutterBottom>Manage Contracts</Typography>
            <Box>
                <SearchResultGrid
                    getRowId={(row: ClientAgencyContract) => row.contract_id}
                    results={contracts}
                    onSelectRow={handleSelectRow}
                    rowSelectionModel={{ type: "include", ids: new Set(selectedContractID ? [selectedContractID] : []) }}
                    columns={clientAgencyContractColumnDef}
                    disableMultipleRowSelection
                />
            </Box>

            {RoleManagement.isSuperAdmin(getUserRole(token)) && (
                <AddClientAgencyContractModal
                    openModal={openContractModal}
                    handleCloseModal={() => setOpenContractModal(false)}
                    fetchContracts={fetchContracts}
                />
            )}

            {RoleManagement.isSuperAdmin(getUserRole(token)) && (
                <ActionConfirmationModal
                    visible={openDeactivateContractModal}
                    onClose={() => setOpenDeactivateContractModal(false)}
                    headerText="Deactivate Contract"
                    bodyText="Are you sure you want to deactivate this contract?"
                    onConfirm={deactivateContract}
                />
            )}
        </Box>
    )
}

export default ManageContracts;
